module.exports = __webpack_public_path__ + "static/getStarted_junior-8ce70697031ac297061f4181f7534d40.svg";